import { render, staticRenderFns } from "./CallSumUp.vue?vue&type=template&id=4682449e&scoped=true"
import script from "./CallSumUp.vue?vue&type=script&lang=js"
export * from "./CallSumUp.vue?vue&type=script&lang=js"
import style0 from "./CallSumUp.vue?vue&type=style&index=0&id=4682449e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682449e",
  null
  
)

export default component.exports